import { render, staticRenderFns } from "./ProgramUnionHistory.vue?vue&type=template&id=5d1ee397&"
import script from "./ProgramUnionHistory.vue?vue&type=script&lang=js&"
export * from "./ProgramUnionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports